import { ADD_VERSION, DELETE_VERSION, GET_VERSIONS } from '../types';
import { createAxiosAction } from '../utils';

export default {
  addVersion: (projectId, name) => {
    return createAxiosAction({
      url: '/api/v1/versions',
      body: { projectId, name },
      method: 'POST',
      startAction: ADD_VERSION,
    });
  },
  deleteVersion: versionId => {
    return createAxiosAction({
      url: `/api/v1/versions/${versionId}`,
      method: 'DELETE',
      startAction: DELETE_VERSION,
    });
  },
  getVersions: projectId => {
    return createAxiosAction({
      url: `/api/v1/projects/${projectId}/versions`,
      startAction: GET_VERSIONS,
    });
  },
};
